import { render, staticRenderFns } from "./index.vue?vue&type=template&id=b46a9f9a&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=b46a9f9a&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\src\\KoRus.Nord\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b46a9f9a')) {
      api.createRecord('b46a9f9a', component.options)
    } else {
      api.reload('b46a9f9a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=b46a9f9a&", function () {
      api.rerender('b46a9f9a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "Assets/Scripts/components/atoms/Container/index.vue"
export default component.exports